import _styled from '@emotion/styled/base';
import { text } from '@hubble/tokens/web';

const Container = _styled('div', {
  target: "evr2h922"
})({
  name: "1fttcpj",
  styles: "display:flex;flex-direction:column"
} );
const Line = _styled('span', {
  target: "evr2h921"
})("display:block;white-space:nowrap;overflow:hidden;text-overflow:clip;font-variant-numeric:tabular-nums;font-feature-settings:'tnum';font-family:", ({
  typeSet
}) => text.typesets.numeric.body[typeSet].fontFamily, ";font-size:", ({
  typeSet
}) => text.typesets.numeric.body[typeSet].fontSize, ";line-height:", ({
  typeSet
}) => text.typesets.numeric.body[typeSet].lineHeight, ";font-weight:", ({
  typeSet
}) => text.typesets.numeric.body[typeSet].fontWeight, ";letter-spacing:", ({
  typeSet
}) => text.typesets.numeric.body[typeSet].letterSpacing, ";");
const Char = _styled('span', {
  target: "evr2h920"
})("color:", ({
  theme,
  isHighlighted
}) => isHighlighted ? theme.colorScheme.content.primary : theme.colorScheme.content.secondary, ";font-weight:", ({
  isHighlighted
}) => isHighlighted ? 600 : 'inherit', ";");

export { Char, Container, Line };
